// import { useParams } from "react-router-dom";
// import data from "/data.json";

// export default function ProductDetail() {
//   const { id } = useParams();

//   const product = data.cables.find((item) => item.id === Number(id));

//   if (!product) {
//     return <div className="text-center py-20">Product not found </div>;
//   }

//   return (
//     <section className="bg-gray-50 min-h-screen py-16">
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="grid lg:grid-cols-2 gap-12">
//           {/* Product Image */}
//           <div>
//             <img
//               src={product.image}
//               alt={product.alt}
//               className="w-full rounded-2xl shadow-lg"
//             />
//           </div>

//           {/* Product Info */}
//           <div>
//             <span className="bg-lime-500 text-black px-4 py-1 rounded-full text-sm font-semibold">
//               {product.category}
//             </span>

//             <h1 className="text-4xl font-bold mt-4">{product.title}</h1>

//             <p className="text-gray-600 mt-6">{product.description}</p>

//             <div className="mt-8">
//               <h3 className="text-xl font-semibold mb-4">Features</h3>

//               <ul className="space-y-2">
//                 {product.features.map((feature, index) => (
//                   <li key={index} className="flex items-center gap-2">
//                     ✅ {feature}
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             <div className="mt-8">
//               <h3 className="text-xl font-semibold mb-4">Specifications</h3>

//               <div className="border rounded-xl overflow-hidden">
//                 {Object.entries(product.specifications).map(([key, value]) => (
//                   <div key={key} className="flex justify-between p-4 border-b">
//                     <span className="font-medium">{key}</span>
//                     <span>{value}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <button className="mt-8 bg-black text-white px-8 py-3 rounded-xl hover:bg-lime-500 hover:text-black transition">
//               Request Quote
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function ProductDetail() {
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const fetchProduct = async () => {
      try {
        setLoading(true);

        const res = await fetch("/data.json", {
          signal: controller.signal,
        });

        if (!res.ok) throw new Error("Failed to load data");

        const data = await res.json();

        const products = data?.cables || [];

        const currentProduct = products.find((item) => item.id === Number(id));

        setProduct(currentProduct || null);

        setRelated(
          products.filter((item) => item.id !== Number(id)).slice(0, 4),
        );
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(true);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();

    return () => controller.abort();
  }, [id]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading Product...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-red-600">
              Something went wrong
            </h2>
            <p className="mt-2 text-gray-600">
              Unable to load product details.
            </p>

            <Link
              to="/"
              className="inline-block mt-6 bg-blue-600 text-white px-6 py-3 rounded-lg"
            >
              Back Home
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (!product) {
    return (
      <>
        <Header />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-3xl font-bold">Product Not Found</h2>

            <Link
              to="/"
              className="inline-block mt-6 bg-blue-600 text-white px-6 py-3 rounded-lg"
            >
              Back Home
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      {/* Breadcrumb */}
      <section className="bg-gray-100 border-b">
        <div className="max-w-7xl mx-auto px-6 py-3 text-xl text-gray-600">
          <span className="mx-2">➤</span>
          <Link to="/">Home</Link>
          <span className="mx-2">/</span>
          <span>{product.title}</span>
        </div>
      </section>

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-slate-900 to-slate-800 text-white">
        <div className="max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-12 items-center">
          <div className="flex justify-center">
            <div className="bg-white rounded-3xl p-8 shadow-2xl">
              <img
                src={product.image}
                alt={product.title}
                className="h-[450px] object-contain"
              />
            </div>
          </div>

          <div>
            <span className="bg-blue-600 px-4 py-1 rounded-full text-sm">
              {product.category}
            </span>

            <h1 className="text-5xl font-bold mt-6">{product.title}</h1>

            <p className="mt-5 text-gray-300 text-lg">
              {product.short_description}
            </p>

            <div className="mt-8 space-y-3">
              <p>
                <strong>Brand:</strong> {product.brand}
              </p>

              <p>
                <strong>Availability:</strong> {product.availability}
              </p>

              <p>
                <strong>Price Range:</strong> {product.price_range}
              </p>
            </div>

            <div className="flex gap-4 mt-8">
              <Link
                to="/contact"
                className="bg-blue-600 hover:bg-blue-700 px-8 py-3 rounded-xl font-medium"
              >
                Request Quote
              </Link>

              <Link
                to="/"
                className="border border-white px-8 py-3 rounded-xl hover:bg-white hover:text-black transition"
              >
                Back
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-6">Product Overview</h2>

          <p className="text-gray-700 leading-8">{product.description}</p>
        </div>
      </section>

      {/* Features */}
      {product.key_features?.length > 0 && (
        <section className="bg-gray-50 py-16">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold mb-10">Key Features</h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {product.key_features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-lg transition"
                >
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center mb-4">
                    ✓
                  </div>

                  <p>{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Specifications */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-8">Technical Specifications</h2>

          <div className="overflow-hidden border rounded-2xl">
            <table className="w-full">
              <tbody>
                <SpecRow title="Brand" value={product.brand} />

                <SpecRow title="Function" value={product.function} />

                <SpecRow title="Application" value={product.application} />

                <SpecRow title="Availability" value={product.availability} />

                <SpecRow title="Price Range" value={product.price_range} />

                <SpecRow
                  title="Working Principle"
                  value={product.working_principle}
                />
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Application */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-6">Applications</h2>

          <div className="bg-white rounded-2xl p-8 shadow-sm">
            {product.application}
          </div>
        </div>
      </section>

      {/* Working Principle */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-6">Working Principle</h2>

          <div className="bg-gray-50 rounded-2xl p-8">
            {product.working_principle}
          </div>
        </div>
      </section>

      {/* Related Products */}
      {related.length > 0 && (
        <section className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl font-bold mb-10">Related Products</h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {related.map((item) => (
                <Link
                  key={item.id}
                  to={`/product/${item.id}`}
                  className="bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                >
                  <div className="p-4">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-48 mx-auto object-contain"
                    />
                  </div>

                  <div className="p-5 border-t">
                    <h3 className="font-semibold line-clamp-2">{item.title}</h3>

                    <p className="text-sm text-gray-500 mt-2">
                      {item.category}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section className="bg-blue-600 text-white py-20">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-4xl font-bold">Need More Information?</h2>

          <p className="mt-4 text-blue-100">
            Contact our team for quotations, technical specifications, and
            customized solutions.
          </p>

          <button className="mt-8 bg-white text-blue-600 px-8 py-3 rounded-xl font-semibold">
            Contact Us
          </button>
        </div>
      </section>

      <Footer />
    </>
  );
}

function SpecRow({ title, value }) {
  return (
    <tr className="border-b">
      <td className="w-1/3 bg-gray-50 px-6 py-4 font-semibold">{title}</td>
      <td className="px-6 py-4 text-gray-700">{value || "N/A"}</td>
    </tr>
  );
}
